export {
  default as waterslide,
  ReactComponent as Waterslide,
} from '@assets/icons/features-and-amenities/waterslide.svg'    
